import { ChangeDetectorRef, Component, Inject } from '@angular/core';
import {
  MatDialog,
  MatDialogRef,
  MAT_DIALOG_DATA,
} from '@angular/material/dialog';
import { SystemsExternalService } from '../crud-service';
import { ToastService } from 'src/app/shared/services/toast/toast.service';
import { MediaObserver } from '@angular/flex-layout';
import { TypeIndexEnum } from 'src/app/domain/registration/enums/type-index.enum';
import { SystemsExternalCrudIndex } from './crud-index';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { take } from 'rxjs';
import { getSystemsExternalTypeDescriptionByValue } from 'src/app/domain/registration/enums/system-external-type.enum';
import { AuthService } from 'src/app/views/auth/shared/auth.service';
import { PermissionService } from 'src/app/shared/permission.service';

@Component({
  selector: 'app-systems-external-index-select',
  templateUrl: './crud-index-select.component.html',
  styleUrls: ['./crud-index.component.sass'],
  providers: [SystemsExternalService],
})
export class SystemsExternalIndexSelectComponent extends SystemsExternalCrudIndex {
  override title: string = 'SELECIONE UM SISTEMA';

  override COLUMNS_TO_SHOW_WEB = ['type', 'name'];

  constructor(
    override dialog: MatDialog,
    override service: SystemsExternalService,
    override toastService: ToastService,
    override mediaObserver: MediaObserver,
    public dialogRefSelect: MatDialogRef<SystemsExternalIndexSelectComponent>,
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    data: {
      type: TypeIndexEnum;
      select: boolean;
      params: any;
    },
    override router: Router,
    protected override cdr: ChangeDetectorRef,
    protected override authService: AuthService,
    override permissionService: PermissionService, 
  ) {
    super(dialog, service, toastService, mediaObserver, router, cdr, authService, permissionService);
    if (data.params) {
      this.params = data.params;
    }

    this.dataSelect = data;
  }

  override loadList(): void {
    if(this.params.type && this.params.partnerId) {
      let formGroupFilter =  this.fb.group({
        type: [this.params.type],
        partner: [this.params.partnerId],
        name: [''],
      });

      this.submitAdvancedFilter(formGroupFilter);
    } else if(this.params.type) {
      let formGroupFilter =  this.fb.group({
        type: [this.params.type],
        name: [''],
      });

      this.submitAdvancedFilter(formGroupFilter);
    } else {
      super.loadList();
    }
  }

  override submitAdvancedFilter(filterForm: FormGroup) {
    let _filterForm = this.getFilters(filterForm.value);
    this.service
      .findByFilter(_filterForm, this.params)
      .pipe(take(1))
      .subscribe((dataWithPagination: any) => {
        let data = dataWithPagination[0];
        this.length = dataWithPagination[1];

        this.dataSource = new MatTableDataSource<any>(
          data.map((item: any) => {
            item['type'] = getSystemsExternalTypeDescriptionByValue(item.type);
            return item;
          })
        );
      });
  }

  private getFilters(filter: any) {
    let params: any = {};

    if (filter.type) params.type = filter.type;

    if (filter.name) params.name = filter.name.toUpperCase();
    else delete params.name;

    return params;
  }

  ngOnInit(): void {
    this.displayedColumns = this.COLUMNS_TO_SHOW_WEB;

  }

  onCancel() {
    this.dialogRefSelect.close();
  }

  onSelect(data: any) {
    this.dialogRefSelect.close(data?.row);
  }
}
